import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { UserAdsModule } from '../../user-ads.module';
import { BaseUserAdsComponent } from '../../abstract-components/base-user-ads.component';
import { ResourceFacade } from '~app/app/~store/facades/resource.facade';
import { PageEvent } from '@angular/material/paginator';
import { EventService } from '~app/app/~shared/services/event.service';
import { GlobalEvent } from '~core/models/shared.models';
import { filter, tap } from 'rxjs';

@Component({
  selector: 'user-ads-list-page',
  standalone: true,
  imports: [UserAdsModule],
  templateUrl: './user-ads-list-page.component.html',
  styleUrl: './user-ads-list-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserAdsListPageComponent extends BaseUserAdsComponent {
  private _resourceFacade = inject(ResourceFacade);
  private _eventService = inject(EventService);

  resources$ = this._resourceFacade.resources$;
  isLoading$ = this._resourceFacade.isLoading$;
  currentError$ = this._resourceFacade.currentError$;
  paginationData$ = this._resourceFacade.paginationData$;

  onGlobalRefresh$ = this._eventService.events$.pipe(
    filter((ev: GlobalEvent) => ev.type === 'REFRESH_DATA'),
    tap(() => this.refreshData())
  );

  refreshData(): void {
    this._resourceFacade.getData({ refresh: true });
  }

  handlePageEvent(e: PageEvent): void {
    this._resourceFacade.setPagination({
      ...(e.pageSize && { itemPerPage: e.pageSize }),
      page: e.pageIndex + 1 || 1
    });
  }
}
